
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavyRainShowersPolartwilightColour as ObiHeavyRainShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-rain-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiHeavyRainShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-heavy-rain-showers-polartwilight-colour',
   elementClass: ObiHeavyRainShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 